<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Delete Carrier] ' + carrier.carrier_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/carriers">Carriers</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/carriers/view/${carrier.id}`">{{ carrier.carrier_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Delete</li>
                </ol>
            </nav>

            <h4 class="page-header">
                <span>Delete: {{ carrier.carrier_name }}</span>
            </h4>

            <div class="alert alert-warning mb-2" v-if="products.length > 0">
                This Carrier is currently in use by {{ products.length }} product(s). Select a Reassign Carrier to start mapping Products & Levels.
            </div>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1"  v-if="products.length > 0">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.reassign_carrier_id, 'text-muted-no': !errors.reassign_carrier_id}">
                                    Re-Assign Carrier:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="reassign_carrier_id" :options="carrierOptions" :class="{'is-invalid': errors.reassign_carrier_id}" />

                                    <div class="text-danger mt-2" v-if="errors.reassign_carrier_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.reassign_carrier_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="alert alert-danger">
                                Confirm Carrier Delete. This cannot be undone.
                            </div>
                        </div>
                    </div>

                    <template  v-if="reassign_carrier_id">
                        <div class="card mb-4" v-for="(product, i) in products">
                            <div class="card-header">
                                <div class="form-inline">
                                    Map Product - <strong>{{ product.product_name }}:</strong>

                                    <div class="form-group ml-3">
                                        <b-form-select v-model="product.reassign_product_id" :options="resassignProductOptions" size="sm" :class="{'is-invalid': errors['products.'+i+'.reassign_product_id']}" />
                                    </div>
                                </div>
                                <div class="text-danger mt-2" v-if="errors['products.'+i+'.reassign_product_id']">
                                    <ul class="list-unstyled">
                                        <li v-for="err in errors['products.'+i+'.reassign_product_id']">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1" v-for="(level, j) in product.levels">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['products.'+i+'.levels.'+j+'.reassign_level_id'], 'text-muted-no': !errors['products.'+i+'.levels.'+j+'.reassign_level_id']}">
                                        {{ level.product_level_name }}:
                                    </div>
                                    <div class="col-md-6 col-12 input-group-sm">
                                        <b-form-select v-model="level.reassign_level_id" :options="resassignLevelOptions(product.reassign_product_id)" :class="{'is-invalid': errors['products.'+i+'.levels.'+j+'.reassign_level_id']}" />

                                        <b-form-checkbox v-model="level.move_to_reassign_product" :value="true" :unchecked-value="false" plain v-if="false">Move Level to {{ reassignProductName(product.reassign_product_id) }}</b-form-checkbox>

                                        <div class="text-danger mt-2" v-if="errors['products.'+i+'.levels.'+j+'.reassign_level_id']">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors['products.'+i+'.levels.'+j+'.reassign_level_id']">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-md-4 col-12" v-if="products.length > 0">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Products ({{ products.length }}) & Levels:</strong>
                        </div>
                        <div class="card-body">
                            <ol class="list-unstyled">
                                <li v-for="product in products">
                                    {{ product.product_name }}
                                    <ol>
                                        <li v-for="level in product.levels">
                                            {{ level.product_level_name }}
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteCarrier()" :disabled="deleting">
                    <template v-if="deleting"><i class="fas fa-spin fa-spinner"></i> Deleting...</template>
                    <template v-else><i class="fas fa-save"></i> Delete</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                reassign_carrier_id: null,
                id: this.$route.params.id,
                carrier: {},
                errors: {},
                products: [],
                other_carriers: [],
                reassign_products: [],
            }
        },

        computed: {
            carrierOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Carrier --'}];

                //Main Loop
                for(var i = 0; i < this.other_carriers.length; i++)
                {
                    options.push({value: this.other_carriers[i].id, text: this.other_carriers[i].carrier_name});
                }

                //Send it
                return options;
            },

            resassignProductOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Product --'}];

                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    options.push({value: this.reassign_products[i].id, text: this.reassign_products[i].product_name});
                }

                //Send it
                return options;
            },
        },

        watch: {
            reassign_carrier_id(newVal, oldVal){
                //Check for a value
                if(newVal == null)
                {
                    //REset
                    this.reassign_products = [];

                    //Stop Here
                    return;
                }

                //Get the Product
                this.getReassignProducts();
            },

            // products: {
            //     deep: true,
            //     handler(newVal){
            //         //Deubbugging
            //         console.log(newVal);

            //         //Check for NULL
            //         if(newVal === null)
            //         {
            //             return;
            //         }

            //         //Recalculate ALL
            //         for (var i = 0; i < this.products.length; i++)
            //         {
            //             //Get the Levels
            //             var levels = this.resassignLevelOptions(this.products[i].reassign_product_id);

            //             //Loop and Process Each Level
            //             for (var j = 0; j < this.products[i].levels.length; j++)
            //             {
            //                 //Check if ANY of the level names match the current level and set it
            //                 this.products[i].levels[j].reassign_level_id = null;

            //                 //Loop and Attempt to set
            //                 for (var t = 0; t < levels.length; t++)
            //                 {
            //                     //Check it
            //                     if(this.products[i].levels[j].product_level_name === levels[t].text)
            //                     {
            //                         this.products[i].levels[j].reassign_level_id = levels[t].value;
            //                     }
            //                 }
            //             }
            //         }

            //         //Update it
            //         this.$forceUpdate();
            //     }
            // },
        },

        methods: {

            getCarrier(){
                //Send it
                this.$http.get('/carriers/delete/' + this.id)
                    .then(response => {
                        //Set the carrier
                        this.carrier = response.data.carrier;
                        this.products = response.data.products;
                        this.other_carriers = response.data.other_carriers;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            getReassignProducts(){
                //Send it
                this.$http.get('/carriers/view/' + this.reassign_carrier_id)
                    .then(response => {
                        //Set the carrier
                        this.reassign_products = response.data.products;

                        // //Recalculate ALL
                        // for (var i = 0; i < this.products.length; i++)
                        // {
                        //     //Set to NULL
                        //     this.products[i].reassign_product_id = null;

                        //     //Loop and Process Each Level
                        //     for (var j = 0; j < this.products[i].levels.length; j++)
                        //     {
                        //         //Check if ANY of the level names match the current level and set it
                        //         this.products[i].levels[j].reassign_level_id = null;
                        //     }
                        // }

                        //Force Update
                        //this.$forceUpdate();
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteCarrier(){
                //Helpers
                this.deleting = true;

                //Reset ERror
                this.errors = {};

                //Send it
                this.$http
                .delete('carriers/delete/'+this.id, {reassign_carrier_id: this.reassign_carrier_id, products: this.products})
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Carrier Deleted');

                    //Return to main list?
                    this.$router.push('/carriers');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Delete Carrier');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },

            resassignLevelOptions(product_id){
                //Setup
                var options = [{value: null, text: '-- Select a Level --'}];

                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    //Check ID
                    if(this.reassign_products[i].id === product_id)
                    {
                        //Main Loop
                        for(var j = 0; j < this.reassign_products[i].levels.length; j++)
                        {
                            options.push({value: this.reassign_products[i].levels[j].id, text: this.reassign_products[i].levels[j].product_level_name});
                        }
                    }
                }

                //Send it
                return options;
            },

            reassignProductName(product_id)
            {
                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    //Check ID
                    if(this.reassign_products[i].id === product_id)
                    {
                        return this.reassign_products[i].product_name;
                    }
                }

                return '';
            }
        },

        mounted() {
            //get the carrier?
            this.getCarrier();
        }
    }
</script>
